<script>
import FormSelect from "@/components/molecules/form-select";
import FormGroup from "@/components/molecules/form-group";
import { useInteractionDoneTracking } from "@/mixins/tracking/interaction-done";

export default {
  name: "Sort",
  components: {
    FormSelect,
    FormGroup
  },
  props: {
    sortCriteria: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  emits: ["sortChange"],
  setup(props) {
    const formSelect = ref(null);
    const { trackEvent } = useInteractionDoneTracking();
    const selectedValue = ref(
      props.sortCriteria[0] && props.sortCriteria[0].valeur
    );
    let activeSort =
      props.sortCriteria &&
      props.sortCriteria.find((value) => value.actif === true);
    selectedValue.value = activeSort && activeSort.valeur;
    return { trackEvent, formSelect, selectedValue };
  },
  computed: {
    sortCriteriaFormatted() {
      return (
        this.sortCriteria &&
        this.sortCriteria.map((sortCriterion) => {
          return {
            text: "Trier par " + sortCriterion.libelle,
            value: sortCriterion.valeur
          };
        })
      );
    }
  },
  methods: {
    sortChange(value, isDefault) {
      this.trackEvent({
        categoryGA: trackingCodes.CATEGORYGA.sort,
        actionGA: this.sortCriteriaFormatted.find((e) => e.value === value)
          .text,
        labelGA: ""
      });

      this.$emit("sortChange", value, this.isDefault(value));
    },
    isDefault(value) {
      let chosenValue = {};
      chosenValue =
        this.sortCriteria &&
        this.sortCriteria.find(
          (sortCriterion) => sortCriterion.valeur === value
        );
      return chosenValue ? chosenValue.defaut : false;
    }
  }
};
</script>
<template>
  <FormGroup inline>
    <FormSelect
      ref="formSelect"
      v-model="selectedValue"
      v-uid
      variant="filter"
      :options="sortCriteriaFormatted"
      size="lg"
      @input="sortChange"
    />
  </FormGroup>
</template>
